
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
import "../css/availabilities-rates.css";
import $$ from "Dom7";
import actions from "../js/actions.js";
import URLS from "../js/Urls.js";

var moment = require("moment");

var events = []; //var loginobj = actions.LoginGetResult();

export default {
  data: function () {
    return {
      loginResult: actions.LoginGetResult(),
      AvailParams: actions.GetAvailabilityParams(),
      // loginobj = actions.LoginGetResult(),
      eventItems: {}
    };
  },

  beforeDestroy() {
    var self = this;
    console.log("componentBeforeDestroy", this);
  },

  on: {
    pageInit: function (e, page) {
      var AvailParams = actions.GetAvailabilityParams();
      var loginResult = actions.LoginGetResult(); //var loginobj = actions.LoginGetResult();

      var self = this;
      var app = self.$app; //

      var $ = self.$; //Get stepper instance

      var mystepper = app.stepper.create({
        el: "#my-stepper",
        min: 0,
        // 15 minutes min
        max: 100 // 4 hours max
        // value: 0,

      });
      mystepper.on("change", stpperhandler);

      function stpperhandler(mystepper, value) {
        renderEvents(Calendar);
      }

      const renderEvents = calendar => {
        var currentDate = calendar.value[0];
        var TempTotalCheckIns = 0;
        var TempTotalCheckOuts = 0;
        var TempTotalNigths = 0;
        currentDate.setHours(0, 0, 0, 0);
        var currentEvents = events;
        var value = mystepper.getValue(); //

        $$(".stepperclass").val(value); //$$("#stepred").val(value);

        var eventItemstemp = [];

        if (currentEvents.length) {
          currentEvents.forEach(function (event) {
            eventItemstemp.push({
              Availability: event.Availability,
              Date: event.Date,
              StepperValue: value
            });
          });
        }

        self.$setState({
          eventItems: eventItemstemp
        });
      };

      var AvailParams = actions.GetAvailabilityParams();
      $$("#CustomBack").on("click", function () {
        if (app.data.currentTab === 1) app.views.main.router.navigate("/main/");else if (app.data.currentTab === 2) app.views.main.router.navigate("/main/reservationscalendar/");else if (app.data.currentTab === 3) app.views.main.router.navigate("/main/reservations/");else if (app.data.currentTab === 4) app.views.main.router.navigate("/main/availabilities/");
      });
      $$("#SaveBtn").on("click", function () {
        var availvalues = [];
        $$(".datestepper").each(function () {
          var dayvalue = $$(this).val();
          availvalues.push(dayvalue);
        });
        var availabilitiyValue = $$("#step").val();

        try {
          let dateFrom = Calendar.value[0];
          let dateTo = Calendar.value[1] ?? dateFrom;
          const CpdateFrom = new Date(JSON.parse(JSON.stringify(dateFrom)));
          const CpdateTo = new Date(JSON.parse(JSON.stringify(dateTo)));
          var Dayslist = [];
          var i = 0;

          for (let d1 = CpdateFrom; d1 <= CpdateTo; d1.setDate(d1.getDate() + 1)) {
            Dayslist[i] = {
              date: moment(d1).format("YYYY-MM-DD"),
              value: availabilitiyValue
            };
            i++;
          }
        } catch {}

        SetRoomAvail(Dayslist);
      });

      async function SetRoomAvail(tempDaylist) {
        var obj = {
          PropertyID: loginResult?.PropertyID,
          RoomCatID: AvailParams.RoomCatID,
          UserID: loginResult?.UserID,
          Daylist: tempDaylist
        };
        app.preloader.show();

        try {
          await app.request.promise.postJSON(URLS.SetRCAvailability, {
            obj
          }).then(res => {
            app.preloader.hide();

            if (res.data == null) {
              app.preloader.hide();
              var toastCheckConnection = app.toast.create({
                text: "Error,check internet connection",
                position: "center",
                closeTimeout: 1500
              }).open();
              return;
            }

            app.dialog.alert(res.data.message, "Update", refresh); //   var toastSuccess = app.toast.create({
            //     text: res.data,
            //     position: 'center',
            //     closeTimeout: 2000,
            //     }).open();
          });
        } catch {
          app.preloader.hide();
          var toastCheckConnection = app.toast.create({
            text: "Error,check internet connection",
            position: "center",
            closeTimeout: 1500
          }).open();
        }
      }

      function refresh() {//
        // Getdata(Calendar.value[0], Calendar.value[1]);
      }

      var page = e.detail.page;
      var initalizedates = [];
      initalizedates.push(new Date(AvailParams.FromDate));

      if (AvailParams.Todate != null) {
        initalizedates.push(new Date(AvailParams.Todate));
      }

      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const Calendar = app.calendar.create({
        containerEl: "#roomstatus-calendar-inline-avail",
        rangePicker: true,
        value: initalizedates,
        weekHeader: false,
        disabled: [{
          from: new Date().minDate,
          to: yesterday
        }],
        renderToolbar: function () {
          return '<div class="toolbar calendar-custom-toolbar no-shadow calendarcustomtoolbar">' + '<div class="toolbar-inner">' + '<div class="left">' + '<a href="#" class="link icon-only"><i class="icon icon-back ' + (app.theme === "md" ? "color-black" : "") + '"></i></a>' + "</div>" + '<div class="center"></div>' + '<div class="right">' + '<a href="#" class="link icon-only"><i class="icon icon-forward ' + (app.theme === "md" ? "color-black" : "") + '"></i></a>' + "</div>" + "</div>" + "</div>";
        },
        on: {
          open: function (c) {
            var fromdate = AvailParams.FromDate;
            c.setYearMonth(fromdate.getFullYear(), fromdate.getMonth(), 0);
            c.update();
            var MyDate = c.value[0].getFullYear() + "-" + (c.value[0].getMonth() + 1) + "-" + c.value[0].getDate();
            var dateFrom = c.value[0];
            var dateTo = c.value[1] ?? null; // Getdata(dateFrom, dateTo); 
            //takis gia events

            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          },
          init: function (c) {
            //
            $(".calendar-custom-toolbar .center").text(monthNames[c.currentMonth] + ", " + c.currentYear);
            $(".calendar-custom-toolbar .left .link").on("click", function () {
              c.prevMonth();
            });
            $(".calendar-custom-toolbar .right .link").on("click", function () {
              c.nextMonth();
            });
          },
          monthYearChangeStart: function (c) {
            var dateFrom = c.value[0];
            var dateTo = c.value[1] ?? null;
            $(".calendar-custom-toolbar .center").text(monthNames[c.currentMonth] + ", " + c.currentYear); //takis gia events

            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          }
        }
      });
      Calendar.on("change", myHandler);

      function myHandler(calendar, value) {
        var dateFrom = calendar.value[0];
        var dateTo = calendar.value[1] ?? null; // Getdata(dateFrom, dateTo);
      }

      function myHandler2(calendar, dayEl, year, month, day) {
        calendar.setValue([new Date(year, month, day)]);
        renderEvents(calendar);
      }

      async function Getdata(dateFrom, dateTo, c) {
        var ResponsAvailabilityData = {};
        ResponsAvailabilityData = await actions.GetAvailabilityData(dateFrom, dateTo, AvailParams.RoomCatID);
        events = [];
        var value = mystepper.getValue();
        ResponsAvailabilityData.forEach(function (item) {
          var re = /-?\d+/;
          var m = re.exec(item.Date);
          var d = new Date(parseInt(m[0]));
          var obj = {
            Date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            // hours: 21,
            // minutes: 0,
            StepperValue: value,
            Availability: item.Availability
          };
          events.push(obj);
        });
        renderEvents(Calendar);
      }

      async function GetEventsdata(dateFrom, dateTo, c) {
        var ResponseGetMonthlyAvailabilityData = {};
        var obj = {
          PropertyID: loginResult?.PropertyID,
          UserID: loginResult?.UserID,
          DateFrom: dateFrom,
          DateTo: dateTo,
          RoomCategoryID: AvailParams.RoomCatID
        };
        app.preloader.show();
        var response = await app.request.promise.postJSON(URLS.GetMonthRoomsDetails, {
          obj
        });
        app.preloader.hide();
        var events = []; // 

        ResponseGetMonthlyAvailabilityData = response.data;
        ResponseGetMonthlyAvailabilityData.forEach(function (item) {
          var d = moment(item.DateStr, "DD/MM/YYYY").toDate();
          var obj = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            // hours: 21,
            // minutes: 0,
            color: item.Color
          };
          var re = /-?\d+/;
          events.push(obj);
        });
        Calendar.params.events = events;
        Calendar.update();
      }
    },

    pageBeforeRemove() {}

  },
  id: '3412bd3ec0',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=setup-availability><!-- Top Navbar --><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding navbar-inner-centered-title"><div class=left><a href=# id=CustomBack class=link><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'SetupAvailability', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=right id=SaveBtn style="margin-right: 10px"><span class=material-icons>save</span></div></div></div><!-- Scrollable page content--><div class="page-content availabilitiespage"><div id=roomstatus-calendar-inline-avail></div><div class=block><div class=row><div class=card><div class="card-content card-content-padding takis"><div class=row><div class=col-100><span><b>';
      r += c(ctx_1.loginResult?.PropertyName, ctx_1);
      r += '</b></span> <span style=float:right;><b>';
      r += c(ctx_1.AvailParams.RoomCatDesc, ctx_1);
      r += '</b></span></div></div><hr><div class=row style="margin-top: 5px;"><div class=col-60 style="margin-top: 12px"><span>Change Availability For All</span></div><div class=col-40 style="display: flex; justify-content: flex-end"><div class=col><div class="stepper stepper-raised stepper-large" id=my-stepper><div class=stepper-button-minus></div><div class=stepper-input-wrap><input id=step type=number value=0 min=0 max=9999 step=1 sreadonly style="height: 100%"></div><div class=stepper-button-plus></div></div></div></div></div><hr><div class=row><div class=col-40><span>Date</span></div><div class=col-60 style="display: flex; justify-content: flex-end"><span>Availabilty (new / current)</span><br></div></div><hr><!---loop for each selected date--> ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.eventItems, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=row class=dates><div class=col-40><span>';
          r += Template7Helpers.FormatDate.call(ctx_2, 3, ctx_2.Date, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span><br></div><div style="display: flex"><div class=numbers><div class="stepper stepper-small stepper-init"><div class=stepper-button-minus></div><div class=stepper-input-wrap><input type=text value=';
          r += c(ctx_2.Availability, ctx_2);
          r += ' min=0 max=100 step=1 id=AvailabilityStepper class="datestepper stepperclass" readonly=readonly></div><div class=stepper-button-plus></div></div><!-- <span> ';
          r += c(ctx_2.StepperValue, ctx_2);
          r += '</span> --></div><div class="numbers currentAvail"><span id=stepred>';
          r += c(ctx_2.Availability, ctx_2);
          r += '</span></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div></div></div><!---toobar bottom---><div class="fab fab-center-bottom color-blue">';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=#><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;"><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="toolbar tabbar toolbar-bottom"><div class=toolbar-inner><a href=/main/ class=tab-link data-route-tab-id=dashboard><i class=material-icons>dashboard </i><span class=tabbar-label>Dashboard</span> </a><a href=/main/reservationscalendar/ class=tab-link data-route-tab-id=reservationscalendar><i class=material-icons>date_range </i><span class=tabbar-label>';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> </a><a href="" class=tab-link data-route-tab-id=""><!-- <i class="icon f7-icons if-not-md">email_fill</i>\r\n                            <i class="icon material-icons md-only">email</i> --> <span class=tabbar-label></span> </a><a href=/main/reservations/ class=tab-link data-route-tab-id=reservations><!-- <i class="icon f7-icons if-not-md">email_fill</i>\r\n                          <i class="icon material-icons md-only">email</i> --> <i class=material-icons>list </i><span class=tabbar-label>Reservations</span> </a>{#unless loginResult?.DisableAvailabilities}} <a href=/main/availabilities/ class=tab-link data-route-tab-id=availabilities><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
      r += ' <a style="pointer-events: none;opacity:0.5;" class=tab-link><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
      r += '</div></div><div class="tabs tabs-routable"><div class="tab page-content" id=dashboard></div><div class="tab page-content" id=reservations></div><div class="tab page-content" id=addbtn></div><div class="tab page-content" id=availabilities></div><div class="tab page-content" id=reservationscalendar></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};
    